import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "text-lg sm:text-lg font-bold text-gray-800 truncate max-w-xl" }
const _hoisted_3 = ["onDragstart", "onDrop"]
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "text-black ml-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "p-2"
}
const _hoisted_8 = ["onDragstart", "onDrop"]
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "text-black ml-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "p-2"
}
const _hoisted_13 = ["onDragstart", "onDrop"]
const _hoisted_14 = { class: "text-black ml-2" }
const _hoisted_15 = {
  key: 0,
  class: "text-sm text-gray-500 pt-2"
}
const _hoisted_16 = {
  key: 0,
  class: "text-sm text-gray-500 pt-2"
}
const _hoisted_17 = { class: "flex justify-between gap-4" }

import { ref, watch } from 'vue'
import { mdiDragVertical, mdiChevronDown } from '@mdi/js'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { useToast } from 'vue-toastification'
import ScheduleService from '@/Network/Services/ScheduleUnitService'
import { useScheduleStore } from '@/pinia-store/useScheduleStore'
import { useErrorToast } from '@/composables/useErrorToast'
import { UpdateVisualizationOrderPayload } from '@/Network/Types/Requests/ScheduleRequests'

interface Position {
  id: number | string
  name: string
}

interface Shift {
  id: number | string
  name: string
  positions: Position[]
}

export interface Scale {
  id: number | string
  name: string
  shifts: Shift[]
}

export interface UnitData {
  id: number | string
  name: string
  schedules: Scale[]
}

type DraggedItem = {
  type: 'scale' | 'shift' | 'position'
  scaleIndex: number
  shiftIndex?: number
  positionIndex?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SortScalesModal',
  props: {
    modalActive: { type: Boolean },
    unitData: {}
  },
  emits: ["close", "save"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const toast = useToast()
const { notifyError } = useErrorToast()
const scheduleService = new ScheduleService()





const sortedScales = ref<Scale[]>([])
const openScales = ref<Set<number | string>>(new Set())
const openShifts = ref<Set<number | string>>(new Set())
const draggedItem = ref<DraggedItem | null>(null)
const isSaving = ref(false)

const scheduleStore = useScheduleStore()

watch(
  () => props.unitData,
  (newUnitData) => {
    sortedScales.value = JSON.parse(JSON.stringify(newUnitData?.schedules || []))
  },
  { immediate: true, deep: true }
)

const toggleAccordion = (id: number | string, type: 'scale' | 'shift') => {
  const targetSet = type === 'scale' ? openScales.value : openShifts.value
  targetSet.has(id) ? targetSet.delete(id) : targetSet.add(id)
}
const isScaleOpen = (id: number | string) => openScales.value.has(id)
const isShiftOpen = (id: number | string) => openShifts.value.has(id)

const onDragStart = (type: DraggedItem['type'], indices: Omit<DraggedItem, 'type'>) => {
  draggedItem.value = { type, ...indices }
}

const onDragEnd = () => {
  draggedItem.value = null
}

const onDrop = (dropType: DraggedItem['type'], dropIndices: Omit<DraggedItem, 'type'>) => {
  if (!draggedItem.value) return
  const { type: dragType, ...dragIndices } = draggedItem.value

  if (dragType === 'scale' && dropType === 'scale') {
    const item = sortedScales.value.splice(dragIndices.scaleIndex, 1)[0]
    sortedScales.value.splice(dropIndices.scaleIndex, 0, item)
  }

  if (dragType === 'shift' && dropType === 'shift') {
    const fromScale = sortedScales.value[dragIndices.scaleIndex]
    const item = fromScale.shifts.splice(dragIndices.shiftIndex!, 1)[0]
    const toScale = sortedScales.value[dropIndices.scaleIndex]
    toScale.shifts.splice(dropIndices.shiftIndex!, 0, item)
  }

  if (dragType === 'position' && dropType === 'position') {
    const fromShift = sortedScales.value[dragIndices.scaleIndex].shifts[dragIndices.shiftIndex!]
    const item = fromShift.positions.splice(dragIndices.positionIndex!, 1)[0]
    const toShift = sortedScales.value[dropIndices.scaleIndex].shifts[dropIndices.shiftIndex!]
    toShift.positions.splice(dropIndices.positionIndex!, 0, item)
  }
}

const handleClose = () => emits('close')

const handleSave = async () => {
  if (isSaving.value || !props.unitData) return
  isSaving.value = true

  const schedulesPayload: UpdateVisualizationOrderPayload = sortedScales.value.map((scale) => {
    const finalOrder: { shift_id: number; position_id: number }[] = []
    scale.shifts.forEach((shift) => {
      shift.positions.forEach((position) => {
        finalOrder.push({
          shift_id: Number(shift.id),
          position_id: Number(position.id)
        })
      })
    })

    return {
      schedule_id: Number(scale.id),
      order: finalOrder
    }
  })

  const finalPayload = {
    schedules: schedulesPayload
  }

  try {
    await scheduleService.updateVisualizationOrder(Number(props.unitData.id), finalPayload)
    // Refetch isolado: a ordenação já foi persistida — falha do reload não pode
    // cair no catch abaixo e virar um erro falso de ordenação.
    await scheduleStore
      .getSchedulesForPage()
      .catch((error) => notifyError(error, 'Não foi possível recarregar as escalas'))

    toast.success('Configuração de visualização efetuada com sucesso!')
    handleClose()
  } catch (error) {
    console.error('Error saving the order:', error)
    notifyError(error, 'Não foi possível salvar a ordenação das escalas.')
  } finally {
    isSaving.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: handleClose,
    "modal-active": _ctx.modalActive,
    "has-footer-border": false,
    maxWidth: "max-w-[721px]"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.unitData?.name) + " - Configuração de visualização ", 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_17, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "95px",
          height: "48px",
          onClick: handleClose
        }),
        _createVNode(FilledButton, {
          text: "Salvar",
          width: "76px",
          height: "48px",
          onClick: handleSave,
          disabled: isSaving.value,
          loading: isSaving.value
        }, null, 8, ["disabled", "loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_TransitionGroup, {
        tag: "div",
        name: "list",
        class: "flex flex-col gap-3 my-[-12px]"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedScales.value, (scale, scaleIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: scale.id,
              class: _normalizeClass(["bg-[#F0F0F4] rounded-lg transition-shadow", {
          'shadow-lg': draggedItem.value?.type === 'scale' && draggedItem.value.scaleIndex === scaleIndex
        }])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["flex items-center justify-between p-2 cursor-move transition-colors duration-300 ease-in-out rounded-t-lg", { 'rounded-b-lg': !isScaleOpen(scale.id) }]),
                draggable: "true",
                onDragstart: _withModifiers(($event: any) => (onDragStart('scale', { scaleIndex })), ["stop"]),
                onDragend: onDragEnd,
                onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                onDrop: _withModifiers(($event: any) => (onDrop('scale', { scaleIndex })), ["stop"])
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiDragVertical),
                    class: "text-gray-500"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(scale.name), 1)
                ]),
                _createElementVNode("button", {
                  onClick: ($event: any) => (toggleAccordion(scale.id, 'scale')),
                  class: "p-1 rounded-full hover:bg-gray-200"
                }, [
                  _createVNode(_component_v_icon, {
                    icon: _unref(mdiChevronDown),
                    class: _normalizeClass(["transition-transform", { 'rotate-180': isScaleOpen(scale.id) }])
                  }, null, 8, ["icon", "class"])
                ], 8, _hoisted_6)
              ], 42, _hoisted_3),
              (isScaleOpen(scale.id))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_TransitionGroup, {
                      tag: "div",
                      name: "list",
                      class: "flex flex-col gap-2"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scale.shifts, (shift, shiftIndex) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: shift.id,
                            class: _normalizeClass(["bg-white rounded-lg transition-shadow", {
                'shadow-md':
                  draggedItem.value?.type === 'shift' &&
                  draggedItem.value.scaleIndex === scaleIndex &&
                  draggedItem.value.shiftIndex === shiftIndex
              }])
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["flex items-center justify-between p-2 cursor-move", { 'rounded-b-lg': !isShiftOpen(shift.id) }]),
                              draggable: "true",
                              onDragstart: _withModifiers(($event: any) => (onDragStart('shift', { scaleIndex, shiftIndex })), ["stop"]),
                              onDragend: onDragEnd,
                              onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                              onDrop: _withModifiers(($event: any) => (onDrop('shift', { scaleIndex, shiftIndex })), ["stop"])
                            }, [
                              _createElementVNode("div", _hoisted_9, [
                                _createVNode(_component_v_icon, {
                                  icon: _unref(mdiDragVertical),
                                  class: "text-gray-400"
                                }, null, 8, ["icon"]),
                                _createElementVNode("span", _hoisted_10, _toDisplayString(shift.name), 1)
                              ]),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (toggleAccordion(shift.id, 'shift')),
                                class: "p-1 rounded-full hover:bg-gray-100"
                              }, [
                                _createVNode(_component_v_icon, {
                                  icon: _unref(mdiChevronDown),
                                  class: _normalizeClass(["transition-transform", { 'rotate-180': isShiftOpen(shift.id) }])
                                }, null, 8, ["icon", "class"])
                              ], 8, _hoisted_11)
                            ], 42, _hoisted_8),
                            (isShiftOpen(shift.id))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createVNode(_TransitionGroup, {
                                    tag: "div",
                                    name: "list",
                                    class: "flex flex-col gap-2"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shift.positions, (position, positionIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: position.id,
                                          class: _normalizeClass(["flex items-center p-3 bg-[#F0F0F4] rounded-md cursor-move", {
                      'opacity-50':
                        draggedItem.value?.type === 'position' &&
                        draggedItem.value.scaleIndex === scaleIndex &&
                        draggedItem.value.shiftIndex === shiftIndex &&
                        draggedItem.value.positionIndex === positionIndex
                    }]),
                                          draggable: "true",
                                          onDragstart: _withModifiers(($event: any) => (
                      onDragStart('position', { scaleIndex, shiftIndex, positionIndex })
                    ), ["stop"]),
                                          onDragend: onDragEnd,
                                          onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                                          onDrop: _withModifiers(($event: any) => (onDrop('position', { scaleIndex, shiftIndex, positionIndex })), ["stop"])
                                        }, [
                                          _createVNode(_component_v_icon, {
                                            icon: _unref(mdiDragVertical),
                                            class: "text-gray-400"
                                          }, null, 8, ["icon"]),
                                          _createElementVNode("span", _hoisted_14, _toDisplayString(position.name), 1)
                                        ], 42, _hoisted_13))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (!shift.positions || !shift.positions.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Nenhuma posição neste turno. "))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024),
                    (!scale.shifts || !scale.shifts.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Nenhum turno nesta escala. "))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})